import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import {Typography} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";
import {useGetProfileQuery} from "../../../../store/api/userApiSlice";

interface BottomBarUIProps {
  isSubmited: boolean;
  onSubmitButtonClick: () => void;
  onNextButtonClick: () => void;
  onPreviousButtonClick: () => void;
}
export default function BottomBarUI({
  isSubmited,
  onSubmitButtonClick,
  onNextButtonClick,
  onPreviousButtonClick,
}: BottomBarUIProps) {
  const {data: userData} = useGetProfileQuery();

  return (
    <Stack direction={"row"} sx={STYLES.bottomBarContainer}>
      <Button
        variant="outlined"
        onClick={() => {
          onPreviousButtonClick();
        }}>
        <Typography fontSize={"inherit"}>Previous</Typography>
      </Button>
      {!isSubmited ? (
        <Button
          onClick={onSubmitButtonClick}
          variant="contained"
          endIcon={
            <MaterialSymbol
              icon="send"
              size={16}
              fill
              style={STYLES.submitButtonIcon}
            />
          }
          sx={{borderRadius: "20px"}}>
          <Typography sx={STYLES.submitButtonText}>Submit Answer</Typography>
        </Button>
      ) : (
        <Button
          onClick={() => {}}
          variant="contained"
          startIcon={
            <MaterialSymbol
              icon="auto_awesome"
              fill
              size={16}
              style={{marginLeft: "6px", marginRight: "-4px"}}
            />
          }
          disabled={!userData}
          sx={{
            backgroundColor: "success.dark",
            borderRadius: "20px",
          }}>
          <Typography fontWeight={600} fontSize={"0.875rem"} my={0.25} mx={1}>
            View Answer
          </Typography>
        </Button>
      )}
      <Button
        variant={isSubmited ? "contained" : "outlined"}
        onClick={() => {
          onNextButtonClick();
        }}>
        <Typography fontSize={"inherit"}>Next</Typography>
      </Button>
    </Stack>
  );
}

const STYLES = {
  bottomBarContainer: {
    width: "50vw",
    justifyContent: "space-between",
    pt: 1,
    pb: 2.5,
  } as const,
  submitButtonIcon: {
    marginLeft: "0px",
    marginRight: "4px",
    marginTop: "1px",
  } as const,
  submitButtonText: {
    fontWeight: 600,
    fontSize: "0.875rem",
    my: 0.25,
    ml: 3,
    mr: 1,
  } as const,
};
